import React from 'react';
import { useTranslation } from 'react-i18next';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './i18n/i18n'; // Initialize i18n
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';

// Components
import Login from './components/auth/Login';
import Layout from './components/common/Layout';
import Home from './components/pages/Home';
import HomeDashboard from './components/pages/HomeDashboard';
import CreateGroup from './components/pages/CreateGroup';
import PaymentsPage from './components/pages/PaymentsPage';
import GroupsPaymentPage from './components/pages/GroupsPaymentPage';
import GeneralPaymentsPage from './components/pages/GeneralPaymentsPage';
import BuySell from './components/pages/BuySell';
import ReceiveCash from './components/pages/ReceiveCash';
import ManageGroups from './components/pages/ManageGroups';
import TravelerExpensesReport from './components/pages/TravelerExpensesReport';
import GroupRevenuesExpensesReport from './components/pages/GroupRevenuesExpensesReport';
import Balances from './components/pages/Balances';
import Balancestravelers from './components/pages/Balancestravelers';
import Balancesagents from './components/pages/Balancesagents';
import Balancessupervisors from './components/pages/Balancessupervisors';
import AccountStatement from './components/pages/AccountStatement';
import TravelersLedger from './components/pages/TravelersLedger';
import InstallmentsQuery from './components/pages/InstallmentsQuery';
import SalesPage from './components/pages/SalesPage';
import AgentsPage from './components/pages/AgentsPage';
import TravelersPage from './components/pages/TravelersPage';
import SupervisorsPage from './components/pages/SupervisorsPage';
import GroupReport from './components/pages/GroupReport';
import TravelerManagement from './components/travelers/TravelerManagement';
import TravelerForm from './components/travelers/TravelerForm';
import TravelerDetails from './components/travelers/TravelerDetails';
import ExpenseManagement from './components/expenses/ExpenseManagement';
import PaymentManagement from './components/payments/PaymentManagement';
import ReportsManagement from './components/reports/ReportsManagement';
import NotFound from './components/errors/NotFound';
import ServerError from './components/errors/ServerError';
import ActiveGroupsTable from "./components/pages/ActiveGroupsTable";
import ManageUsers from './components/pages/ManageUsers';
import OngoingInstallments from './components/pages/OngoingInstallments';
import ReceivedPayments from './components/pages/ReceivedPayments';
import MessageReports from './pages/MessageReports';
import MissingRecipients from './pages/MissingRecipients';

import PrivateRoute from './components/common/PrivateRoute';
import './App.css';
// Dev-only API debug overlay removed

function App() {
  const token = localStorage.getItem('auth_token');
  const { i18n } = useTranslation();
  const isRTL = (typeof i18n?.dir === 'function') ? (i18n.dir() === 'rtl') : (i18n?.language === 'ar');

  return (
    <ThemeProvider>
      <LanguageProvider>
        <Router>
          <div className="App">
            <Routes>
              {/* صفحة تسجيل الدخول (بدون حماية) */}
              <Route path="/login" element={<Login />} />

              {/* الصفحات المحمية */}
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <Layout>
                      <HomeDashboard />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/home-legacy"
                element={
                  <PrivateRoute>
                    <Layout>
                      <Home />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/create-group"
                element={
                  <PrivateRoute>
                    <Layout>
                      <CreateGroup />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/groups/:id/edit"
                element={
                  <PrivateRoute>
                    <Layout>
                      <CreateGroup />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/PaymentsPage"
                element={
                  <PrivateRoute>
                    <Layout>
                      <PaymentsPage />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/GroupsPaymentPage"
                element={
                  <PrivateRoute>
                    <Layout>
                      <GroupsPaymentPage />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/general-payments"
                element={
                  <PrivateRoute>
                    <Layout>
                      <GeneralPaymentsPage />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/SalesPage"
                element={
                  <PrivateRoute>
                    <Layout>
                      <SalesPage />
                    </Layout>
                  </PrivateRoute>
                }
              />    
              <Route
                path="/AgentsPage"
                element={
                  <PrivateRoute>
                    <Layout>
                      <AgentsPage />
                    </Layout>
                  </PrivateRoute>
                }
              />       
              <Route
                path="/TravelersPage"
                element={
                  <PrivateRoute>
                    <Layout>
                      <TravelersPage />
                    </Layout>
                  </PrivateRoute>
                }
              />    
              <Route
                path="/SupervisorsPage"
                element={
                  <PrivateRoute>
                    <Layout>
                      <SupervisorsPage />
                    </Layout>
                  </PrivateRoute>
                }
              />                                                 
              <Route
                path="/buy-sell"
                element={
                  <PrivateRoute>
                    <Layout>
                      <BuySell />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/receive-cash"
                element={
                  <PrivateRoute>
                    <Layout>
                      <ReceiveCash />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/manage-groups"
                element={
                  <PrivateRoute>
                    <Layout>
                      <ManageGroups />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/reports/traveler-expenses"
                element={
                  <PrivateRoute>
                    <Layout>
                      <TravelerExpensesReport />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/reports/group-revenues-expenses"
                element={
                  <PrivateRoute>
                    <Layout>
                      <GroupRevenuesExpensesReport />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/balances"
                element={
                  <PrivateRoute>
                    <Layout>
                      <Balances />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/Balancestravelers"
                element={
                  <PrivateRoute>
                    <Layout>
                      <Balancestravelers />
                    </Layout>
                  </PrivateRoute>
                }
              />         
              <Route
                path="/Balancesagents"
                element={
                  <PrivateRoute>
                    <Layout>
                      <Balancesagents />
                    </Layout>
                  </PrivateRoute>
                }
              />           
              <Route
                path="/Balancessupervisors"
                element={
                  <PrivateRoute>
                    <Layout>
                      <Balancessupervisors />
                    </Layout>
                  </PrivateRoute>
                }
              />               
              <Route
                path="/account-statement"
                element={
                  <PrivateRoute>
                    <Layout>
                      <AccountStatement />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/TravelersLedger"
                element={
                  <PrivateRoute>
                    <Layout>
                      <TravelersLedger />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/received-payments"
                element={
                  <PrivateRoute>
                    <Layout>
                      <ReceivedPayments />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/group-report"
                element={
                  <PrivateRoute>
                    <Layout>
                      <GroupReport />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/InstallmentsQuery"
                element={
                  <PrivateRoute>
                    <Layout>
                      <InstallmentsQuery />
                    </Layout>
                  </PrivateRoute>
                }
              />              
              <Route
                path="/installments-ongoing"
                element={
                  <PrivateRoute>
                    <Layout>
                      <OngoingInstallments />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/travelers"
                element={
                  <PrivateRoute>
                    <Layout>
                      <TravelerManagement />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/travelers/new"
                element={
                  <PrivateRoute>
                    <Layout>
                      <TravelerForm />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/travelers/edit/:id"
                element={
                  <PrivateRoute>
                    <Layout>
                      <TravelerForm />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/travelers/:id"
                element={
                  <PrivateRoute>
                    <Layout>
                      <TravelerDetails />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/expenses"
                element={
                  <PrivateRoute>
                    <Layout>
                      <ExpenseManagement />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/payments"
                element={
                  <PrivateRoute>
                    <Layout>
                      <PaymentManagement />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/daily-schedule"
                element={
                  <PrivateRoute>
                    <Layout>
                      <div>Daily Schedule - Coming Soon</div>
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/reports"
                element={
                  <PrivateRoute>
                    <Layout>
                      <ReportsManagement />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/active-groups"
                element={
                  <PrivateRoute>
                    <Layout>
                      <ActiveGroupsTable />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/manage-users"
                element={
                  <PrivateRoute>
                    <Layout>
                      <ManageUsers />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/message-reports"
                element={
                  <PrivateRoute>
                    <Layout>
                      <MessageReports />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/missing-recipients"
                element={
                  <PrivateRoute>
                    <Layout>
                      <MissingRecipients />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/manage-expenses"
                element={
                  <PrivateRoute>
                    <Layout>
                      <div>Manage Expenses - Coming Soon</div>
                    </Layout>
                  </PrivateRoute>
                }
              />

              {/* أخطاء */}
              <Route path="/404" element={<NotFound />} />
              <Route path="/500" element={<ServerError />} />
              <Route path="*" element={<Navigate to="/404" replace />} />
            </Routes>

            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={isRTL}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />
          </div>
        </Router>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
